import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {
    private authenticationService = inject(AuthenticationService);

    async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
        return this.authenticationService.isAuthenticatedTryRespawnSession();
        // session.interceptor redirects to '/' on 401, 403
    }
}
